{ "id": "nishi-west", "light": 0.6,
 "_note": "2x art scene: Nishi-Shinjuku west (station line, corporate towers, office plazas, loading podiums). Cosmetic only; see kabuki-crossing.json for the field notes. Tile units.",
 "rect": {
  "x": 0,
  "y": 96,
  "w": 128,
  "h": 48
 },
 "buildings": [
  { "id": "w-a",
   "x": 0,
   "y": 101,
   "w": 3,
   "h": 14,
   "face": 4,
   "kind": "nishiWestTower",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "NISHI",
    "color": "cyan"
   },
   "props": [
    ["nishiWestChiller", 0.1, 2],
    ["nishiWestMast", 1.4, 6]
   ]
  },
  { "id": "w-b",
   "x": 0,
   "y": 115,
   "w": 3,
   "h": 14,
   "face": 3,
   "kind": "nishiWestPodium",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "DENKI",
    "color": "pink"
   },
   "props": [
    ["nishiWestSolar", 0.4, 2],
    ["nishiWestChiller", 0.3, 6]
   ]
  },
  { "id": "w-c",
   "x": 0,
   "y": 129,
   "w": 3,
   "h": 15,
   "face": 4,
   "kind": "nishiWestTower",
   "roof": "nishiWestGlass",
   "sign": {
    "text": "DENKI",
    "color": "amber"
   },
   "props": [
    ["nishiWestMast", 1.4, 3],
    ["nishiWestSolar", 0.5, 7]
   ]
  },
  { "id": "hall",
   "x": 13,
   "y": 101,
   "w": 24,
   "h": 4,
   "face": 3,
   "kind": "nishiWestStation",
   "roof": "nishiWestGlass",
   "sign": {
    "text": "シンジュク",
    "color": "cyan"
   },
   "props": []
  },
  { "id": "metro-tw",
   "x": 47,
   "y": 101,
   "w": 9,
   "h": 7,
   "face": 4,
   "kind": "nishiWestTower",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "SHINJUKU",
    "color": "cyan"
   },
   "props": [
    ["nishiWestMast", 4, 1.2],
    ["nishiWestChiller", 0.8, 0.3]
   ]
  },
  { "id": "arc-tw",
   "x": 64,
   "y": 101,
   "w": 9,
   "h": 7,
   "face": 4,
   "kind": "nishiWestTower",
   "roof": "nishiWestGlass",
   "sign": {
    "text": "TERMINAL",
    "color": "cyan"
   },
   "props": [
    ["nishiWestSolar", 1, 0.5],
    ["nishiWestSolar", 4.5, 0.5],
    ["nishiWestMast", 8, 1.5]
   ]
  },
  { "id": "stn-b",
   "x": 83,
   "y": 101,
   "w": 15,
   "h": 7,
   "face": 4,
   "kind": "nishiWestStation",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "メトロ",
    "color": "amber"
   },
   "props": [
    ["nishiWestChiller", 1, 0.4],
    ["nishiWestChiller", 5, 0.4],
    ["nishiWestSolar", 10, 0.5]
   ]
  },
  { "id": "mall",
   "x": 98,
   "y": 101,
   "w": 15,
   "h": 7,
   "face": 4,
   "kind": "nishiWestMall",
   "roof": "nishiWestGlass",
   "sign": {
    "text": "SHOP",
    "color": "pink"
   },
   "props": [
    ["nishiWestMast", 13.5, 1.5]
   ]
  },
  { "id": "e-tower",
   "x": 123,
   "y": 101,
   "w": 5,
   "h": 7,
   "face": 4,
   "kind": "nishiWestTower",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "GENKAI",
    "color": "cyan"
   },
   "props": [
    ["nishiWestChiller", 0.5, 0.4],
    ["nishiWestMast", 3.5, 2]
   ]
  },
  { "id": "hq-a",
   "x": 13,
   "y": 118,
   "w": 12,
   "h": 13,
   "face": 6,
   "kind": "nishiWestTower",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "MIRAI",
    "color": "cyan"
   },
   "props": [
    ["nishiWestHeli", 4, 2.5],
    ["nishiWestMast", 1, 1],
    ["nishiWestChiller", 7.5, 0.6],
    ["nishiWestSolar", 1, 4.5]
   ]
  },
  { "id": "hq-b",
   "x": 25,
   "y": 118,
   "w": 12,
   "h": 13,
   "face": 6,
   "kind": "nishiWestTower",
   "roof": "nishiWestGlass",
   "sign": {
    "text": "BIOTEK",
    "color": "pink"
   },
   "props": [
    ["nishiWestChiller", 1, 1],
    ["nishiWestMast", 10.5, 1],
    ["nishiWestSolar", 6, 4.5]
   ]
  },
  { "id": "off-a",
   "x": 83,
   "y": 118,
   "w": 12,
   "h": 13,
   "face": 5,
   "kind": "nishiWestTower",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "NISHI",
    "color": "cyan"
   },
   "props": [
    ["nishiWestChiller", 1, 1],
    ["nishiWestChiller", 5, 1],
    ["nishiWestSolar", 2, 5],
    ["nishiWestMast", 9.5, 2.5]
   ]
  },
  { "id": "off-b",
   "x": 101,
   "y": 118,
   "w": 12,
   "h": 13,
   "face": 5,
   "kind": "nishiWestTower",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "DENKI",
    "color": "pink"
   },
   "props": [
    ["nishiWestSolar", 1, 1],
    ["nishiWestChiller", 6, 1.2],
    ["nishiWestHeli", 2, 4.2]
   ]
  },
  { "id": "e-off",
   "x": 123,
   "y": 118,
   "w": 5,
   "h": 13,
   "face": 5,
   "kind": "nishiWestTower",
   "roof": "nishiWestGlass",
   "sign": {
    "text": "ARC",
    "color": "cyan"
   },
   "props": [
    ["nishiWestMast", 2, 2],
    ["nishiWestSolar", 1.2, 5]
   ]
  },
  { "id": "atr-a",
   "x": 47,
   "y": 125,
   "w": 13,
   "h": 6,
   "face": 4,
   "kind": "nishiWestAtrium",
   "roof": "nishiWestGlass",
   "sign": {
    "text": "ATRIUM",
    "color": "cyan"
   },
   "props": [
    ["nishiWestChiller", 1, 0.2],
    ["nishiWestMast", 11, 1]
   ]
  },
  { "id": "atr-b",
   "x": 60,
   "y": 125,
   "w": 13,
   "h": 6,
   "face": 4,
   "kind": "nishiWestMall",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "SHOP",
    "color": "amber"
   },
   "props": [
    ["nishiWestChiller", 2, 0.2],
    ["nishiWestSolar", 8, 0.2]
   ]
  },
  { "id": "pod-1",
   "x": 3,
   "y": 141,
   "w": 20,
   "h": 3,
   "face": 2,
   "kind": "nishiWestPodium",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "PARKING",
    "color": "pink"
   },
   "props": [
    ["ac", 3, 0.2]
   ]
  },
  { "id": "pod-2",
   "x": 23,
   "y": 141,
   "w": 20,
   "h": 3,
   "face": 2,
   "kind": "nishiWestPodium",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "CARGO",
    "color": "amber"
   },
   "props": [
    ["nishiWestMast", 10, 0.4]
   ]
  },
  { "id": "pod-3",
   "x": 43,
   "y": 141,
   "w": 20,
   "h": 3,
   "face": 2,
   "kind": "nishiWestPodium",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "PARKING",
    "color": "cyan"
   },
   "props": []
  },
  { "id": "pod-4",
   "x": 63,
   "y": 141,
   "w": 20,
   "h": 3,
   "face": 2,
   "kind": "nishiWestPodium",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "DENKI",
    "color": "pink"
   },
   "props": [
    ["ac", 12, 0.2]
   ]
  },
  { "id": "pod-5",
   "x": 83,
   "y": 141,
   "w": 20,
   "h": 3,
   "face": 2,
   "kind": "nishiWestPodium",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "CARGO",
    "color": "cyan"
   },
   "props": [
    ["nishiWestMast", 5, 0.4]
   ]
  },
  { "id": "pod-6",
   "x": 103,
   "y": 141,
   "w": 25,
   "h": 3,
   "face": 2,
   "kind": "nishiWestPodium",
   "roof": "nishiWestPlate",
   "sign": {
    "text": "PARKING",
    "color": "amber"
   },
   "props": [
    ["ac", 6, 0.2],
    ["nishiWestSolar", 14, 0]
   ]
  }
 ],
 "lamps": [
  [5.6, 98, "e"],
  [10.4, 98, "w"],
  [5.6, 104, "e"],
  [10.4, 104, "w"],
  [5.6, 119, "e"],
  [10.4, 119, "w"],
  [5.6, 126, "e"],
  [10.4, 126, "w"],
  [5.6, 131, "e"],
  [10.4, 131, "w"],
  [5.6, 139, "e"],
  [10.4, 139, "w"],
  [39.6, 98, "e"],
  [44.4, 98, "w"],
  [39.6, 104, "e"],
  [44.4, 104, "w"],
  [39.6, 119, "e"],
  [44.4, 119, "w"],
  [39.6, 126, "e"],
  [44.4, 126, "w"],
  [39.6, 131, "e"],
  [44.4, 131, "w"],
  [39.6, 139, "e"],
  [44.4, 139, "w"],
  [75.6, 98, "e"],
  [80.4, 98, "w"],
  [75.6, 104, "e"],
  [80.4, 104, "w"],
  [75.6, 119, "e"],
  [80.4, 119, "w"],
  [75.6, 126, "e"],
  [80.4, 126, "w"],
  [75.6, 131, "e"],
  [80.4, 131, "w"],
  [75.6, 139, "e"],
  [80.4, 139, "w"],
  [115.6, 98, "e"],
  [120.4, 98, "w"],
  [115.6, 104, "e"],
  [120.4, 104, "w"],
  [115.6, 119, "e"],
  [120.4, 119, "w"],
  [115.6, 126, "e"],
  [120.4, 126, "w"],
  [115.6, 131, "e"],
  [120.4, 131, "w"],
  [115.6, 139, "e"],
  [120.4, 139, "w"],
  [14, 110.6, "s"],
  [14, 115.4, "n"],
  [14, 133.6, "s"],
  [14, 138.4, "n"],
  [22, 110.6, "s"],
  [22, 115.4, "n"],
  [22, 133.6, "s"],
  [22, 138.4, "n"],
  [30, 110.6, "s"],
  [30, 115.4, "n"],
  [30, 133.6, "s"],
  [30, 138.4, "n"],
  [48, 110.6, "s"],
  [48, 115.4, "n"],
  [48, 133.6, "s"],
  [48, 138.4, "n"],
  [56, 110.6, "s"],
  [56, 115.4, "n"],
  [56, 133.6, "s"],
  [56, 138.4, "n"],
  [64, 110.6, "s"],
  [64, 115.4, "n"],
  [64, 133.6, "s"],
  [64, 138.4, "n"],
  [70, 110.6, "s"],
  [60, 115.4, "n"],
  [70, 133.6, "s"],
  [70, 138.4, "n"],
  [88, 110.6, "s"],
  [88, 115.4, "n"],
  [88, 133.6, "s"],
  [88, 138.4, "n"],
  [96, 110.6, "s"],
  [96, 115.4, "n"],
  [96, 133.6, "s"],
  [96, 138.4, "n"],
  [104, 110.6, "s"],
  [98, 115.4, "n"],
  [104, 133.6, "s"],
  [104, 138.4, "n"],
  [122, 110.6, "s"],
  [122, 115.4, "n"],
  [122, 133.6, "s"],
  [122, 138.4, "n"]
 ]
}
